// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-CodeEditor-module__root"};